// extracted by mini-css-extract-plugin
export default {"geoCoordinate":"GeospatialCoordinate-module__geoCoordinate___VSHUM"};